"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.carouselClasses = void 0;
var _mui = require("@ori-ui/mui");
const carouselClasses = exports.carouselClasses = (0, _mui.generateUtilityClasses)('Carousel', ['root', 'inner', 'header', 'title', 'compactButtonsRoot']);
